import type { Software } from "@/types";

const socialShots = [
  "https://readdy.ai/api/search-image?query=Mobile%20chat%20application%20interface%20screenshot%20with%20message%20list%20and%20colorful%20avatars%2C%20clean%20modern%20Chinese%20social%20app%20UI%20design%2C%20soft%20light%20background%2C%20high%20detail%20flat%20illustration&width=400&height=800&seq=shot-social-a1&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Social%20feed%20mobile%20screen%20mockup%20with%20posts%20likes%20and%20comments%2C%20friendly%20modern%20Chinese%20app%20interface%2C%20rounded%20cards%20and%20warm%20accent%20buttons%2C%20clean%20editorial%20flat%20style&width=400&height=800&seq=shot-social-a2&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Team%20collaboration%20mobile%20app%20interface%20with%20task%20board%20and%20group%20chat%2C%20professional%20blue%20accent%20Chinese%20productivity%20UI%2C%20minimal%20clean%20layout%20high%20detail%20flat%20illustration&width=400&height=800&seq=shot-social-a3&orientation=portrait",
];

const toolsShots = [
  "https://readdy.ai/api/search-image?query=Phone%20utility%20app%20dashboard%20screenshot%20with%20storage%20cleanup%20and%20speed%20boost%20widgets%2C%20modern%20minimal%20Chinese%20tool%20interface%2C%20light%20background%20soft%20shadows%20flat%20style&width=400&height=800&seq=shot-tools-b1&orientation=portrait",
  "https://readdy.ai/api/search-image?query=File%20manager%20mobile%20interface%20with%20folders%20and%20documents%20list%2C%20clean%20professional%20Chinese%20app%20UI%20design%2C%20neutral%20palette%20rounded%20icons%20high%20detail%20flat%20illustration&width=400&height=800&seq=shot-tools-b2&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Keyboard%20input%20and%20calculator%20mobile%20screens%20mockup%2C%20simple%20modern%20Chinese%20utility%20app%20interface%2C%20bright%20clean%20layout%20minimal%20flat%20style%20high%20quality&width=400&height=800&seq=shot-tools-b3&orientation=portrait",
];

const gamesShots = [
  "https://readdy.ai/api/search-image?query=Mobile%20battle%20game%20interface%20with%20hero%20characters%20and%20skill%20buttons%2C%20vibrant%20fantasy%20Chinese%20mobile%20game%20UI%2C%20dramatic%20lighting%20rich%20colors%20high%20detail%20digital%20art&width=400&height=800&seq=shot-games-c1&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Mobile%20RPG%20adventure%20game%20screen%20with%20map%20and%20quest%20panels%2C%20colorful%20anime%20style%20Chinese%20game%20interface%2C%20immersive%20fantasy%20scene%20high%20quality%20illustration&width=400&height=800&seq=shot-games-c2&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Strategy%20mobile%20game%20interface%20with%20isometric%20city%20and%20resource%20bars%2C%20cartoon%20Chinese%20game%20UI%20design%2C%20bright%20playful%20palette%20high%20detail%20digital%20art&width=400&height=800&seq=shot-games-c3&orientation=portrait",
];

const lifeShots = [
  "https://readdy.ai/api/search-image?query=Food%20delivery%20mobile%20app%20interface%20with%20restaurant%20list%20and%20dishes%2C%20warm%20appetizing%20Chinese%20local%20service%20UI%2C%20clean%20modern%20layout%20high%20detail%20flat%20style&width=400&height=800&seq=shot-life-d1&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Travel%20booking%20mobile%20screen%20with%20map%20and%20hotel%20cards%2C%20fresh%20modern%20Chinese%20travel%20app%20interface%2C%20soft%20blue%20tones%20minimal%20flat%20illustration&width=400&height=800&seq=shot-life-d2&orientation=portrait",
  "https://readdy.ai/api/search-image?query=Shopping%20and%20parcel%20tracking%20mobile%20app%20interface%2C%20friendly%20modern%20Chinese%20lifestyle%20UI%20design%2C%20rounded%20cards%20warm%20accent%20colors%20high%20detail%20flat%20style&width=400&height=800&seq=shot-life-d3&orientation=portrait",
];

export const softwareList: Software[] = [
  /* ---------------- 社交聊天 ---------------- */
  {
    id: "weixin",
    name: "微聊",
    icon: "https://readdy.ai/api/search-image?query=Mobile%20messenger%20app%20icon%20with%20two%20chat%20bubbles%2C%20modern%20flat%20rounded%20square%20design%2C%20fresh%20green%20gradient%20background%2C%20clean%20minimal%20high%20quality%20vector%20style&width=200&height=200&seq=app-weixin&orientation=squarish",
    categoryId: "social",
    version: "8.0.48",
    size: "256 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "深讯科技",
    tags: ["即时通讯", "社交动态", "支付"],
    shortDesc: "国民级即时通讯应用，支持聊天、语音视频通话、朋友圈与移动支付。",
    description:
      "微聊是一款综合性即时通讯应用，围绕日常沟通打造了聊天、语音视频通话、群组协作、朋友圈动态与移动支付等完整能力。界面简洁易上手，消息加密传输保障隐私，适合个人社交与小型团队协作使用。",
    features: [
      "支持单聊、群聊与多人实时语音视频通话",
      "朋友圈动态分享，支持图片、短视频与文字",
      "内置移动支付与生活服务入口",
      "消息加密传输，保护个人隐私安全",
    ],
    screenshots: socialShots,
    updatedAt: "2026-09-28",
    downloads: 986000000,
    rating: 4.8,
    downloadUrl: "https://my3okwj.cn/store/search?q=微信",
  },
  {
    id: "qq",
    name: "Q讯",
    icon: "https://readdy.ai/api/search-image?query=Mobile%20chat%20app%20icon%20with%20friendly%20penguin%20silhouette%2C%20playful%20flat%20rounded%20square%20design%2C%20bright%20blue%20gradient%20background%2C%20clean%20modern%20high%20quality%20vector%20style&width=200&height=200&seq=app-qq&orientation=squarish",
    categoryId: "social",
    version: "9.1.25",
    size: "312 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "深讯科技",
    tags: ["即时通讯", "兴趣社区", "影音娱乐"],
    shortDesc: "面向年轻用户的多功能社交平台，聊天、群组、兴趣社区一应俱全。",
    description:
      "Q讯是深受年轻用户喜爱的综合性社交平台，除了基础聊天功能外，还提供兴趣群组、动态广场、在线课堂与影音娱乐等丰富玩法，满足从社交到娱乐的多场景需求。",
    features: [
      "支持消息漫游与多端同步",
      "兴趣群组与动态广场，发现同好",
      "群视频、屏幕共享，适合线上聚会",
      "丰富个性化装扮与表情主题",
    ],
    screenshots: socialShots,
    updatedAt: "2026-09-30",
    downloads: 872000000,
    rating: 4.7,
    downloadUrl: "https://my3okwj.cn/store/search?q=QQ",
  },
  {
    id: "weibo",
    name: "微博客",
    icon: "https://readdy.ai/api/search-image?query=Social%20media%20app%20icon%20with%20speech%20bubble%20and%20hot%20topic%20symbol%2C%20modern%20flat%20rounded%20square%20design%2C%20warm%20orange%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-weibo&orientation=squarish",
    categoryId: "social",
    version: "14.2.1",
    size: "198 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "浪花网络",
    tags: ["社交动态", "热点资讯", "短视频"],
    shortDesc: "开放式社交媒体平台，实时热点、明星动态与短视频应有尽有。",
    description:
      "微博客是以短内容为核心的开放式社交媒体，用户可以发布文字、图片与视频动态，关注感兴趣的人与话题，第一时间了解全球热点事件与名人动态。",
    features: [
      "实时热搜榜，掌握最新热点",
      "关注流与推荐流双模式浏览",
      "支持图文与短视频发布",
      "超话社区，聚集兴趣圈子",
    ],
    screenshots: socialShots,
    updatedAt: "2026-09-25",
    downloads: 615000000,
    rating: 4.5,
    downloadUrl: "https://my3okwj.cn/store/search?q=微博",
  },
  {
    id: "dingtalk",
    name: "钉钉办公",
    icon: "https://readdy.ai/api/search-image?query=Business%20productivity%20app%20icon%20with%20lightning%20bolt%20symbol%2C%20clean%20flat%20rounded%20square%20design%2C%20professional%20blue%20gradient%20background%2C%20minimal%20high%20quality%20vector%20style&width=200&height=200&seq=app-dingtalk&orientation=squarish",
    categoryId: "social",
    version: "7.6.30",
    size: "268 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "蚁阵数科",
    tags: ["职场协作", "办公", "视频会议"],
    shortDesc: "数字化办公协作平台，覆盖考勤、审批、会议与云文档。",
    description:
      "钉钉办公面向企业与团队提供一站式数字化协作能力，包含即时沟通、音视频会议、考勤打卡、流程审批与云文档协作等模块，帮助团队高效运转。",
    features: [
      "高清音视频会议，支持百人同时在线",
      "智能考勤与审批流程",
      "云文档多人实时协作编辑",
      "组织架构与权限管理",
    ],
    screenshots: socialShots,
    updatedAt: "2026-09-20",
    downloads: 482000000,
    rating: 4.6,
    downloadUrl: "https://my3okwj.cn/store/search?q=钉钉",
  },
  {
    id: "momo",
    name: "陌遇",
    icon: "https://readdy.ai/api/search-image?query=Social%20discovery%20app%20icon%20with%20location%20pin%20and%20heart%2C%20modern%20flat%20rounded%20square%20design%2C%20soft%20purple%20pink%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-momo&orientation=squarish",
    categoryId: "social",
    version: "8.9.6",
    size: "176 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "陌川科技",
    tags: ["附近社交", "语音直播", "兴趣交友"],
    shortDesc: "基于地理位置的社交应用，发现附近有趣的人与实时直播。",
    description:
      "陌遇是一款基于地理位置的社交应用，帮助用户发现附近的人、参与兴趣话题并观看实时语音直播，营造轻松友好的陌生人社交氛围。",
    features: [
      "附近动态与兴趣匹配",
      "语音直播间互动",
      "动态相册与个性标签",
      "隐私距离设置保护安全",
    ],
    screenshots: socialShots,
    updatedAt: "2026-09-18",
    downloads: 254000000,
    rating: 4.2,
    downloadUrl: "https://my3okwj.cn/store/search?q=陌陌",
  },
  {
    id: "tantan",
    name: "探探交友",
    icon: "https://readdy.ai/api/search-image?query=Dating%20app%20icon%20with%20two%20interlocking%20hearts%2C%20modern%20flat%20rounded%20square%20design%2C%20vibrant%20coral%20red%20gradient%20background%2C%20clean%20minimal%20high%20quality%20vector%20style&width=200&height=200&seq=app-tantan&orientation=squarish",
    categoryId: "social",
    version: "6.4.9",
    size: "148 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "探奇科技",
    tags: ["兴趣交友", "匹配推荐", "动态"],
    shortDesc: "主打左右滑匹配的社交应用，帮助用户轻松认识新朋友。",
    description:
      "探探交友采用简洁的滑动匹配方式，帮助用户根据兴趣标签与地理位置认识新朋友，通过互相喜欢后开启聊天，降低社交压力。",
    features: [
      "左右滑动手势快速匹配",
      "兴趣标签精准推荐",
      "实名认证与举报机制",
      "动态分享展示真实自我",
    ],
    screenshots: socialShots,
    updatedAt: "2026-09-16",
    downloads: 168000000,
    rating: 4.1,
    downloadUrl: "https://my3okwj.cn/store/search?q=探探",
  },
  {
    id: "soul",
    name: "灵魂星球",
    icon: "https://readdy.ai/api/search-image?query=Anonymous%20social%20app%20icon%20with%20glowing%20planet%20and%20stars%2C%20modern%20flat%20rounded%20square%20design%2C%20deep%20indigo%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-soul&orientation=squarish",
    categoryId: "social",
    version: "5.7.2",
    size: "162 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "灵犀互动",
    tags: ["匿名社交", "兴趣匹配", "语音房间"],
    shortDesc: "以兴趣与性格匹配为核心的匿名社交应用，主打深聊与陪伴。",
    description:
      "灵魂星球主打基于性格与兴趣的灵魂匹配，用户通过测试获得个性标签，在匿名状态下进行深聊、参与语音房间，寻找真正合拍的朋友。",
    features: [
      "性格测试与兴趣标签匹配",
      "匿名树洞倾诉心事",
      "语音派对房间互动",
      "星球广场发现同频灵魂",
    ],
    screenshots: socialShots,
    updatedAt: "2026-09-22",
    downloads: 132000000,
    rating: 4.3,
    downloadUrl: "https://my3okwj.cn/store/search?q=soul",
  },
  {
    id: "feishu",
    name: "飞书协同",
    icon: "https://readdy.ai/api/search-image?query=Collaboration%20app%20icon%20with%20paper%20plane%20and%20document%2C%20modern%20flat%20rounded%20square%20design%2C%20balanced%20blue%20teal%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-feishu&orientation=squarish",
    categoryId: "social",
    version: "7.20.6",
    size: "288 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "星宇科技",
    tags: ["职场协作", "云文档", "会议"],
    shortDesc: "先进团队协作平台，整合文档、表格、会议与即时沟通。",
    description:
      "飞书协同将即时沟通、云文档、多维表格与音视频会议深度融合，为团队提供高效的协作体验，支持跨设备无缝衔接与丰富自动化能力。",
    features: [
      "文档、表格与多维表格一体化",
      "视频会议支持实时字幕",
      "机器人助手自动化提醒",
      "开放平台连接企业应用",
    ],
    screenshots: socialShots,
    updatedAt: "2026-09-26",
    downloads: 96000000,
    rating: 4.6,
    downloadUrl: "https://my3okwj.cn/store/search?q=飞书",
  },
  {
    id: "maimai",
    name: "脉脉职场",
    icon: "https://readdy.ai/api/search-image?query=Professional%20networking%20app%20icon%20with%20handshake%20symbol%2C%20clean%20flat%20rounded%20square%20design%2C%20calm%20navy%20blue%20gradient%20background%2C%20minimal%20high%20quality%20vector%20style&width=200&height=200&seq=app-maimai&orientation=squarish",
    categoryId: "social",
    version: "6.8.4",
    size: "128 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "脉动科技",
    tags: ["职场社交", "招聘", "行业圈子"],
    shortDesc: "职场人脉社交平台，拓展行业人脉、获取职场资讯与机会。",
    description:
      "脉脉职场是面向职场人的社交网络，帮助用户结识同行、了解行业动态、关注企业信息并获取职业发展机会，打造专业人脉圈。",
    features: [
      "实名职场人脉推荐",
      "行业动态与公司点评",
      "关注企业招聘职位",
      "匿名职场交流社区",
    ],
    screenshots: socialShots,
    updatedAt: "2026-09-12",
    downloads: 78000000,
    rating: 4.0,
    downloadUrl: "https://my3okwj.cn/store/search?q=脉脉",
  },
  {
    id: "yidui",
    name: "伊对",
    icon: "https://readdy.ai/api/search-image?query=Video%20dating%20app%20icon%20with%20camera%20and%20heart%20symbol%2C%20modern%20flat%20rounded%20square%20design%2C%20warm%20pink%20coral%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-yidui&orientation=squarish",
    categoryId: "social",
    version: "5.2.8",
    size: "156 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "伊对网络",
    tags: ["视频社交", "相亲", "直播"],
    shortDesc: "以视频相亲为特色的社交应用，真人红娘助力脱单。",
    description:
      "伊对以视频相亲与直播互动为特色，提供真人红娘主持的相亲房间，帮助用户通过实时视频更真实地认识对方，提升交友效率。",
    features: [
      "真人红娘主持视频相亲",
      "实时视频聊天互动",
      "兴趣标签智能推荐",
      "多重实名认证保障安全",
    ],
    screenshots: socialShots,
    updatedAt: "2026-09-08",
    downloads: 64000000,
    rating: 4.1,
    downloadUrl: "https://my3okwj.cn/store/search?q=伊对",
  },

  /* ---------------- 实用工具 ---------------- */
  {
    id: "phone-manager",
    name: "手机管家",
    icon: "https://readdy.ai/api/search-image?query=Phone%20cleaner%20utility%20app%20icon%20with%20shield%20and%20sparkle%2C%20modern%20flat%20rounded%20square%20design%2C%20fresh%20green%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-manager&orientation=squarish",
    categoryId: "tools",
    version: "9.4.12",
    size: "86 MB",
    platforms: ["android"],
    price: "free",
    developer: "清源软件",
    tags: ["系统优化", "安全防护", "清理加速"],
    shortDesc: "集垃圾清理、加速优化与安全防护于一体的手机管家。",
    description:
      "手机管家提供垃圾清理、内存加速、病毒查杀与隐私保护等一站式功能，帮助安卓手机保持流畅稳定的运行状态。",
    features: [
      "一键垃圾清理释放存储空间",
      "后台应用冻结与内存加速",
      "病毒查杀与支付环境保护",
      "应用锁与隐私保险箱",
    ],
    screenshots: toolsShots,
    updatedAt: "2026-10-02",
    downloads: 342000000,
    rating: 4.5,
    downloadUrl: "https://my3okwj.cn/store/search?q=手机管家",
  },
  {
    id: "kuaiya",
    name: "快牙传输",
    icon: "https://readdy.ai/api/search-image?query=File%20transfer%20app%20icon%20with%20two%20arrows%20exchanging%20data%2C%20modern%20flat%20rounded%20square%20design%2C%20energetic%20cyan%20blue%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-kuaiya&orientation=squarish",
    categoryId: "tools",
    version: "6.9.3",
    size: "42 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "快传科技",
    tags: ["文件管理", "传输", "免流量"],
    shortDesc: "无需网络、不耗流量的极速文件互传工具。",
    description:
      "快牙传输通过本地直连技术实现手机之间零流量极速互传，支持大文件、应用与相册一键迁移，换机传输更加省心。",
    features: [
      "本地直连，无需 WiFi 与流量",
      "传输速度可达每秒数十兆",
      "一键换机迁移应用与相册",
      "支持断点续传与批量传输",
    ],
    screenshots: toolsShots,
    updatedAt: "2026-09-29",
    downloads: 216000000,
    rating: 4.4,
    downloadUrl: "https://my3okwj.cn/store/search?q=快牙",
  },
  {
    id: "es-files",
    name: "极速文件管理器",
    icon: "https://readdy.ai/api/search-image?query=File%20manager%20app%20icon%20with%20folder%20and%20magnifier%2C%20clean%20flat%20rounded%20square%20design%2C%20professional%20blue%20gradient%20background%2C%20minimal%20high%20quality%20vector%20style&width=200&height=200&seq=app-esfiles&orientation=squarish",
    categoryId: "tools",
    version: "4.3.7",
    size: "38 MB",
    platforms: ["android"],
    price: "free",
    developer: "极速工作室",
    tags: ["文件管理", "云盘", "播放器"],
    shortDesc: "简洁高效的文件管理器，支持分类整理、云盘与媒体播放。",
    description:
      "极速文件管理器以直观的分类视图帮助用户快速整理手机文件，支持压缩解压、云盘挂载、隐藏文件与多种媒体格式播放。",
    features: [
      "按类型智能分类文件",
      "支持压缩包解压与云盘挂载",
      "内置高清视频音频播放器",
      "批量重命名与文件加密",
    ],
    screenshots: toolsShots,
    updatedAt: "2026-09-15",
    downloads: 158000000,
    rating: 4.3,
    downloadUrl: "https://my3okwj.cn/store/search?q=ES文件浏览器",
  },
  {
    id: "calculator",
    name: "全能计算器",
    icon: "https://readdy.ai/api/search-image?query=Calculator%20app%20icon%20with%20plus%20minus%20multiply%20symbols%2C%20clean%20flat%20rounded%20square%20design%2C%20neutral%20blue%20gradient%20background%2C%20minimal%20high%20quality%20vector%20style&width=200&height=200&seq=app-calc&orientation=squarish",
    categoryId: "tools",
    version: "3.8.1",
    size: "18 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "数感科技",
    tags: ["效率工具", "计算", "换算"],
    shortDesc: "集科学计算、单位换算与房贷计算于一体的多功能计算器。",
    description:
      "全能计算器涵盖基础计算、科学计算、单位换算、房贷税费与汇率换算等多种实用场景，界面清爽，结果精准，是日常计算的得力助手。",
    features: [
      "基础与科学计算双模式",
      "长度、重量、面积等单位换算",
      "房贷、个税与汇率计算",
      "计算历史记录随时查看",
    ],
    screenshots: toolsShots,
    updatedAt: "2026-09-10",
    downloads: 187000000,
    rating: 4.7,
    downloadUrl: "https://my3okwj.cn/store/search?q=计算器",
  },
  {
    id: "voice-to-text",
    name: "录音转文字助手",
    icon: "https://readdy.ai/api/search-image?query=Speech%20to%20text%20app%20icon%20with%20microphone%20and%20text%20lines%2C%20modern%20flat%20rounded%20square%20design%2C%20vibrant%20teal%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-vtt&orientation=squarish",
    categoryId: "tools",
    version: "5.6.2",
    size: "52 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "语智科技",
    tags: ["效率工具", "语音识别", "会议记录"],
    shortDesc: "实时录音转文字，支持会议记录与语音速记。",
    description:
      "录音转文字助手可将会议、采访与课堂录音快速转换为可编辑文字，支持实时转写、多语言识别与导出分享，提升记录效率。",
    features: [
      "实时语音转文字，识别准确率高",
      "支持多种语言与方言",
      "录音文件导入批量转写",
      "一键导出文本与分享",
    ],
    screenshots: toolsShots,
    updatedAt: "2026-09-24",
    downloads: 92000000,
    rating: 4.4,
    downloadUrl: "https://my3okwj.cn/store/search?q=录音转文字",
  },
  {
    id: "clean-master",
    name: "手机清理大师",
    icon: "https://readdy.ai/api/search-image?query=Phone%20cleaning%20app%20icon%20with%20broom%20and%20sparkles%2C%20modern%20flat%20rounded%20square%20design%2C%20bright%20green%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-clean&orientation=squarish",
    categoryId: "tools",
    version: "7.1.5",
    size: "64 MB",
    platforms: ["android"],
    price: "free",
    developer: "清源软件",
    tags: ["系统优化", "清理加速", "省电"],
    shortDesc: "深度清理缓存与冗余文件，让手机持久流畅。",
    description:
      "手机清理大师专注垃圾清理与性能优化，可深度扫描缓存、残留与冗余文件，并提供省电模式与自启动管理，让旧手机焕发新生。",
    features: [
      "深度扫描缓存与残留文件",
      "微信、短视频专清",
      "智能省电与自启动管理",
      "大文件与重复文件清理",
    ],
    screenshots: toolsShots,
    updatedAt: "2026-10-01",
    downloads: 264000000,
    rating: 4.2,
    downloadUrl: "https://my3okwj.cn/store/search?q=手机清理",
  },
  {
    id: "screen-recorder",
    name: "屏幕录制大师",
    icon: "https://readdy.ai/api/search-image?query=Screen%20recorder%20app%20icon%20with%20recording%20dot%20and%20play%20symbol%2C%20modern%20flat%20rounded%20square%20design%2C%20bold%20red%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-recorder&orientation=squarish",
    categoryId: "tools",
    version: "4.5.9",
    size: "46 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "影录科技",
    tags: ["效率工具", "录屏", "直播"],
    shortDesc: "高清无时长限制的录屏工具，支持内录与剪辑。",
    description:
      "屏幕录制大师支持高清录屏、内部音频录制、悬浮窗控制与视频剪辑，广泛适用于游戏录制、教程制作与内容创作。",
    features: [
      "高清录屏，支持 60 帧流畅录制",
      "内录声音，可同时录制麦克风",
      "悬浮窗一键启停与画笔标注",
      "内置剪辑与视频压缩导出",
    ],
    screenshots: toolsShots,
    updatedAt: "2026-09-19",
    downloads: 143000000,
    rating: 4.5,
    downloadUrl: "https://my3okwj.cn/store/search?q=屏幕录制",
  },
  {
    id: "iflytek-keyboard",
    name: "讯飞输入法",
    icon: "https://readdy.ai/api/search-image?query=Virtual%20keyboard%20app%20icon%20with%20key%20and%20speech%20wave%2C%20modern%20flat%20rounded%20square%20design%2C%20fresh%20blue%20cyan%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-keyboard&orientation=squarish",
    categoryId: "tools",
    version: "12.4.0",
    size: "98 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "语智科技",
    tags: ["输入法", "语音输入", "效率工具"],
    shortDesc: "支持语音、手写与拼音的智能输入法，打字更快更准。",
    description:
      "讯飞输入法融合语音、手写、拼音与笔画等多种输入方式，语音识别速度快，支持方言与中英混说，并配备丰富主题与词库。",
    features: [
      "语音输入快人一步，支持方言识别",
      "手写与拼音无缝切换",
      "智能联想与云词库同步",
      "海量主题皮肤个性化定制",
    ],
    screenshots: toolsShots,
    updatedAt: "2026-09-27",
    downloads: 320000000,
    rating: 4.6,
    downloadUrl: "https://my3okwj.cn/store/search?q=讯飞输入法",
  },
  {
    id: "wifi-key",
    name: "WiFi 万能钥匙",
    icon: "https://readdy.ai/api/search-image?query=WiFi%20app%20icon%20with%20key%20and%20signal%20waves%2C%20modern%20flat%20rounded%20square%20design%2C%20fresh%20blue%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-wifi&orientation=squarish",
    categoryId: "tools",
    version: "5.8.3",
    size: "54 MB",
    platforms: ["android"],
    price: "free",
    developer: "连网科技",
    tags: ["网络", "WiFi", "安全防护"],
    shortDesc: "一键连接周边优质 WiFi，并提供网络安全检测。",
    description:
      "WiFi 万能钥匙帮助用户在公共场所快速找到并连接可用热点，同时提供网络测速、安全检测与蹭网监测，守护上网体验。",
    features: [
      "一键连接周边共享热点",
      "网络测速与延迟检测",
      "WiFi 安全风险扫描",
      "防蹭网与网络诊断",
    ],
    screenshots: toolsShots,
    updatedAt: "2026-09-13",
    downloads: 276000000,
    rating: 4.1,
    downloadUrl: "https://my3okwj.cn/store/search?q=WiFi万能钥匙",
  },
  {
    id: "flashlight",
    name: "超级手电筒",
    icon: "https://readdy.ai/api/search-image?query=Flashlight%20app%20icon%20with%20glowing%20bulb%20and%20beam%2C%20modern%20flat%20rounded%20square%20design%2C%20bright%20yellow%20amber%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-flash&orientation=squarish",
    categoryId: "tools",
    version: "3.2.6",
    size: "12 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "点亮工作室",
    tags: ["效率工具", "照明", "实用"],
    shortDesc: "轻量实用的手电筒工具，支持 SOS 闪烁与多种灯效。",
    description:
      "超级手电筒体积小巧、启动迅速，除基础照明外还提供 SOS 求救闪烁、屏幕补光与多彩灯效，是出行应急的实用小工具。",
    features: [
      "一键开启高亮照明",
      "SOS 紧急闪烁模式",
      "屏幕补光与彩色灯效",
      "极简界面，占用空间极小",
    ],
    screenshots: toolsShots,
    updatedAt: "2026-09-05",
    downloads: 198000000,
    rating: 4.3,
    downloadUrl: "https://my3okwj.cn/store/search?q=手电筒",
  },

  /* ---------------- 手机游戏 ---------------- */
  {
    id: "honor-of-kings",
    name: "王者对决",
    icon: "https://readdy.ai/api/search-image?query=Fantasy%20MOBA%20game%20app%20icon%20with%20hero%20helmet%20and%20swords%2C%20epic%20flat%20rounded%20square%20design%2C%20gold%20blue%20gradient%20background%2C%20high%20quality%20vector%20style&width=200&height=200&seq=app-moba&orientation=squarish",
    categoryId: "games",
    version: "9.2.10",
    size: "1.9 GB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "天美互动",
    tags: ["竞技对战", "MOBA", "组队开黑"],
    shortDesc: "国民级 5v5 竞技手游，公平对战，英雄众多。",
    description:
      "王者对决是一款 5v5 多人在线竞技手游，拥有上百位风格各异的英雄与公平的竞技环境，支持排位赛、娱乐模式与好友开黑，随时随地享受竞技乐趣。",
    features: [
      "5v5 实时对战，节奏紧凑",
      "上百位英雄自由搭配",
      "排位与娱乐多种模式",
      "低配置优化，流畅运行",
    ],
    screenshots: gamesShots,
    updatedAt: "2026-10-03",
    downloads: 728000000,
    rating: 4.4,
    downloadUrl: "https://my3okwj.cn/store/search?q=王者荣耀",
  },
  {
    id: "battle-royale",
    name: "生存竞技",
    icon: "https://readdy.ai/api/search-image?query=Battle%20royale%20shooter%20game%20app%20icon%20with%20parachute%20and%20helmet%2C%20epic%20flat%20rounded%20square%20design%2C%20dark%20orange%20gradient%20background%2C%20high%20quality%20vector%20style&width=200&height=200&seq=app-br&orientation=squarish",
    categoryId: "games",
    version: "3.9.8",
    size: "1.8 GB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "光速工作室",
    tags: ["竞技对战", "射击", "组队"],
    shortDesc: "百人同场竞技的战术竞技手游，真实战场体验。",
    description:
      "生存竞技是一款百人战术竞技射击手游，玩家从跳伞落地开始收集装备，在不断缩小的安全区内与队友配合生存到最后，享受紧张刺激的对抗体验。",
    features: [
      "百人同场，真实弹道与载具",
      "多张地图与实时天气系统",
      "语音开黑，团队配合",
      "高清画质与帧率自由调节",
    ],
    screenshots: gamesShots,
    updatedAt: "2026-09-30",
    downloads: 612000000,
    rating: 4.3,
    downloadUrl: "https://my3okwj.cn/store/search?q=和平精英",
  },
  {
    id: "genshin",
    name: "原界幻想",
    icon: "https://readdy.ai/api/search-image?query=Open%20world%20anime%20RPG%20game%20app%20icon%20with%20winged%20emblem%2C%20elegant%20flat%20rounded%20square%20design%2C%20teal%20gold%20gradient%20background%2C%20high%20quality%20vector%20style&width=200&height=200&seq=app-rpg&orientation=squarish",
    categoryId: "games",
    version: "5.4.0",
    size: "3.2 GB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "米游互娱",
    tags: ["角色扮演", "开放世界", "冒险"],
    shortDesc: "开放世界冒险 RPG，探索七国大陆与元素战斗。",
    description:
      "原界幻想是一款开放世界冒险角色扮演游戏，玩家可自由探索广阔大陆、解开谜题、收集角色，并体验元素反应带来的策略战斗乐趣。",
    features: [
      "无缝开放世界自由探索",
      "元素反应策略战斗",
      "丰富角色养成与剧情",
      "支持多人联机组队冒险",
    ],
    screenshots: gamesShots,
    updatedAt: "2026-10-04",
    downloads: 356000000,
    rating: 4.7,
    downloadUrl: "https://my3okwj.cn/store/search?q=原神",
  },
  {
    id: "onmyoji",
    name: "妖灵录",
    icon: "https://readdy.ai/api/search-image?query=Japanese%20style%20demon%20RPG%20game%20app%20icon%20with%20paper%20talisman%2C%20elegant%20flat%20rounded%20square%20design%2C%20deep%20red%20black%20gradient%20background%2C%20high%20quality%20vector%20style&width=200&height=200&seq=app-onmyoji&orientation=squarish",
    categoryId: "games",
    version: "1.7.42",
    size: "2.4 GB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "和风互娱",
    tags: ["角色扮演", "卡牌", "回合制"],
    shortDesc: "唯美和风卡牌 RPG，收集式神体验回合制策略。",
    description:
      "妖灵录以精致和风美术与深度回合制策略为特色，玩家收集各式妖灵进行养成与组队，在剧情与副本中体验独具韵味的东方幻想世界。",
    features: [
      "精美和风美术与声优配音",
      "妖灵收集与深度养成",
      "回合制策略战斗，阵容搭配",
      "丰富剧情与限时活动",
    ],
    screenshots: gamesShots,
    updatedAt: "2026-09-26",
    downloads: 148000000,
    rating: 4.5,
    downloadUrl: "https://my3okwj.cn/store/search?q=阴阳师",
  },
  {
    id: "arknights",
    name: "明日方舟线",
    icon: "https://readdy.ai/api/search-image?query=Strategy%20tower%20defense%20game%20app%20icon%20with%20hexagon%20shield%2C%20modern%20flat%20rounded%20square%20design%2C%20dark%20gray%20cyan%20gradient%20background%2C%20high%20quality%20vector%20style&width=200&height=200&seq=app-arknights&orientation=squarish",
    categoryId: "games",
    version: "2.3.21",
    size: "1.6 GB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "鹰角互娱",
    tags: ["策略战争", "塔防", "二次元"],
    shortDesc: "都市废土风策略塔防，部署干员迎战涌来的敌人。",
    description:
      "明日方舟线是一款策略塔防手游，玩家在关卡中部署不同职业的干员抵御敌人进攻，凭借合理的站位与技能时机赢得战斗，兼具策略深度与精美立绘。",
    features: [
      "策略塔防玩法，考验部署思路",
      "百余位干员自由搭配",
      "精美立绘与沉浸剧情",
      "丰富的关卡与活动内容",
    ],
    screenshots: gamesShots,
    updatedAt: "2026-09-21",
    downloads: 116000000,
    rating: 4.6,
    downloadUrl: "https://my3okwj.cn/store/search?q=明日方舟",
  },
  {
    id: "identity-v",
    name: "庄园迷影",
    icon: "https://readdy.ai/api/search-image?query=Asymmetric%20horror%20game%20app%20icon%20with%20gothic%20mansion%20window%2C%20dark%20flat%20rounded%20square%20design%2C%20deep%20brown%20teal%20gradient%20background%2C%20high%20quality%20vector%20style&width=200&height=200&seq=app-idv&orientation=squarish",
    categoryId: "games",
    version: "6.8.5",
    size: "2.1 GB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "庄影工作室",
    tags: ["竞技对战", "非对称", "悬疑"],
    shortDesc: "非对称对抗手游，逃出生天或猎杀追捕的博弈。",
    description:
      "庄园迷影是一款非对称对抗手游，一方扮演猎手追捕，另一方扮演求生者协作破解机关逃离庄园，紧张的角色博弈与哥特氛围带来独特体验。",
    features: [
      "非对称 1v4 对抗玩法",
      "独特哥特悬疑美术风格",
      "丰富角色与限定皮肤",
      "排位匹配与好友组队",
    ],
    screenshots: gamesShots,
    updatedAt: "2026-09-17",
    downloads: 132000000,
    rating: 4.2,
    downloadUrl: "https://my3okwj.cn/store/search?q=第五人格",
  },
  {
    id: "clash",
    name: "部落冲突战",
    icon: "https://readdy.ai/api/search-image?query=Strategy%20base%20building%20game%20app%20icon%20with%20castle%20and%20barbarian%20helmet%2C%20cartoon%20flat%20rounded%20square%20design%2C%20green%20gold%20gradient%20background%2C%20high%20quality%20vector%20style&width=200&height=200&seq=app-clash&orientation=squarish",
    categoryId: "games",
    version: "16.2.4",
    size: "268 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "战旗互娱",
    tags: ["策略战争", "经营", "联盟"],
    shortDesc: "经典策略经营手游，建造部落、训练军队与好友并肩作战。",
    description:
      "部落冲突战结合基地建造与实时对战，玩家发展自己的部落、训练多样兵种，并加入联盟与其他玩家协作征战，体验策略经营的乐趣。",
    features: [
      "建造升级自己的部落村庄",
      "多样兵种与法术搭配进攻",
      "加入联盟参与部落战",
      "定期更新赛季与新内容",
    ],
    screenshots: gamesShots,
    updatedAt: "2026-09-11",
    downloads: 224000000,
    rating: 4.4,
    downloadUrl: "https://my3okwj.cn/store/search?q=部落冲突",
  },
  {
    id: "three-kingdoms",
    name: "三国志战略版",
    icon: "https://readdy.ai/api/search-image?query=Ancient%20Chinese%20strategy%20game%20app%20icon%20with%20war%20flag%20and%20scroll%2C%20flat%20rounded%20square%20design%2C%20crimson%20gold%20gradient%20background%2C%20high%20quality%20vector%20style&width=200&height=200&seq=app-sanguo&orientation=squarish",
    categoryId: "games",
    version: "3.1.9",
    size: "1.2 GB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "谋略互娱",
    tags: ["策略战争", "历史", "联盟"],
    shortDesc: "以三国为背景的策略战争手游，运筹帷幄问鼎中原。",
    description:
      "三国志战略版是一款以三国历史为背景的策略手游，玩家招募名将、发展城池、结盟征战，在真实的战场沙盘上运筹帷幄，逐鹿中原。",
    features: [
      "真实沙盘大地图战略对抗",
      "数百位三国名将招募养成",
      "联盟结盟与攻城战",
      "策略兵种与战法搭配",
    ],
    screenshots: gamesShots,
    updatedAt: "2026-09-19",
    downloads: 108000000,
    rating: 4.3,
    downloadUrl: "https://my3okwj.cn/store/search?q=三国志战略版",
  },
  {
    id: "menghuan",
    name: "梦幻西游手游",
    icon: "https://readdy.ai/api/search-image?query=Chinese%20fantasy%20MMORPG%20game%20app%20icon%20with%20cloud%20and%20lotus%2C%20elegant%20flat%20rounded%20square%20design%2C%20jade%20green%20gold%20gradient%20background%2C%20high%20quality%20vector%20style&width=200&height=200&seq=app-menghuan&orientation=squarish",
    categoryId: "games",
    version: "1.5.108",
    size: "2.6 GB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "西游互娱",
    tags: ["角色扮演", "回合制", "社交"],
    shortDesc: "经典回合制 MMORPG，师徒结拜伙伴同行。",
    description:
      "梦幻西游手游延续经典回合制玩法，玩家可选择门派角色，结交伙伴、组队刷副本、参与帮派活动，在唯美的东方世界中体验丰富社交与养成。",
    features: [
      "经典回合制战斗玩法",
      "拜师结拜，社交丰富",
      "门派职业多样养成",
      "宠物、装备与帮派系统",
    ],
    screenshots: gamesShots,
    updatedAt: "2026-09-23",
    downloads: 96000000,
    rating: 4.5,
    downloadUrl: "https://my3okwj.cn/store/search?q=梦幻西游",
  },
  {
    id: "mole",
    name: "摩尔庄园",
    icon: "https://readdy.ai/api/search-image?query=Cute%20casual%20farming%20game%20app%20icon%20with%20mole%20and%20carrot%2C%20playful%20flat%20rounded%20square%20design%2C%20sky%20blue%20green%20gradient%20background%2C%20high%20quality%20vector%20style&width=200&height=200&seq=app-mole&orientation=squarish",
    categoryId: "games",
    version: "2.0.16",
    size: "486 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "乐游互娱",
    tags: ["模拟经营", "休闲", "社交"],
    shortDesc: "治愈系模拟经营手游，经营庄园、装扮家园与好友串门。",
    description:
      "摩尔庄园是一款轻松治愈的模拟经营手游，玩家在自己的庄园里种植、钓鱼、装扮房屋，还能拜访好友、参加节日活动，享受惬意悠闲的田园时光。",
    features: [
      "种植养殖与庄园经营",
      "自由装扮房屋与外观",
      "好友串门与互动小游戏",
      "季节活动与限定装扮",
    ],
    screenshots: gamesShots,
    updatedAt: "2026-09-14",
    downloads: 88000000,
    rating: 4.4,
    downloadUrl: "https://my3okwj.cn/store/search?q=摩尔庄园",
  },

  /* ---------------- 生活服务 ---------------- */
  {
    id: "meituan",
    name: "美生活",
    icon: "https://readdy.ai/api/search-image?query=Local%20life%20service%20app%20icon%20with%20fork%20and%20delivery%20bag%2C%20modern%20flat%20rounded%20square%20design%2C%20bright%20yellow%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-meituan&orientation=squarish",
    categoryId: "life",
    version: "12.9.4",
    size: "212 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "美生活科技",
    tags: ["美食外卖", "到店", "出行"],
    shortDesc: "一站式本地生活服务平台，外卖、到店、酒店出行全覆盖。",
    description:
      "美生活是综合性本地生活服务平台，提供外卖点餐、到店团购、酒店预订与共享出行等服务，帮助用户便捷解决日常吃穿住行需求。",
    features: [
      "外卖点餐，实时骑手配送",
      "到店团购优惠与预约排队",
      "酒店机票与出行服务",
      "会员福利与红包优惠",
    ],
    screenshots: lifeShots,
    updatedAt: "2026-10-05",
    downloads: 856000000,
    rating: 4.6,
    downloadUrl: "https://my3okwj.cn/store/search?q=美团",
  },
  {
    id: "eleme",
    name: "饿了点",
    icon: "https://readdy.ai/api/search-image?query=Food%20delivery%20app%20icon%20with%20noodle%20bowl%20and%20chopsticks%2C%20modern%20flat%20rounded%20square%20design%2C%20fresh%20blue%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-eleme&orientation=squarish",
    categoryId: "life",
    version: "11.5.2",
    size: "186 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "蓝骑科技",
    tags: ["美食外卖", "生鲜", "药品"],
    shortDesc: "外卖点餐与即时零售平台，饭菜生鲜药品随叫随到。",
    description:
      "饿了点提供外卖点餐、生鲜果蔬、药品应急与跑腿代购等服务，覆盖广泛城市与商户，让日常所需快速送达。",
    features: [
      "外卖点餐，准时达保障",
      "生鲜果蔬与商超即时配送",
      "买药应急，夜间也能送",
      "红包优惠与会员折扣",
    ],
    screenshots: lifeShots,
    updatedAt: "2026-10-01",
    downloads: 348000000,
    rating: 4.5,
    downloadUrl: "https://my3okwj.cn/store/search?q=饿了么",
  },
  {
    id: "amap",
    name: "高德导航",
    icon: "https://readdy.ai/api/search-image?query=Navigation%20app%20icon%20with%20location%20pin%20and%20route%20path%2C%20modern%20flat%20rounded%20square%20design%2C%20fresh%20blue%20green%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-amap&orientation=squarish",
    categoryId: "life",
    version: "13.8.0",
    size: "264 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "行者科技",
    tags: ["出行导航", "打车", "地图"],
    shortDesc: "精准导航与出行服务平台，实时路况、公交打车一站搞定。",
    description:
      "高德导航提供精准的地图导航、实时路况与多方式出行规划，整合打车、公交地铁、骑行步行等出行服务，是日常出行的得力助手。",
    features: [
      "实时路况与智能避堵路线",
      "驾车、公交、步行多方式导航",
      "一键打车与共享出行",
      "语音播报与离线地图",
    ],
    screenshots: lifeShots,
    updatedAt: "2026-10-04",
    downloads: 682000000,
    rating: 4.7,
    downloadUrl: "https://my3okwj.cn/store/search?q=高德地图",
  },
  {
    id: "ctrip",
    name: "携程旅行",
    icon: "https://readdy.ai/api/search-image?query=Travel%20booking%20app%20icon%20with%20airplane%20and%20suitcase%2C%20modern%20flat%20rounded%20square%20design%2C%20calm%20blue%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-ctrip&orientation=squarish",
    categoryId: "life",
    version: "8.72.6",
    size: "238 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "途程科技",
    tags: ["旅行住宿", "机票", "度假"],
    shortDesc: "一站式旅行预订平台，机票酒店门票度假全覆盖。",
    description:
      "携程旅行提供机票、酒店、火车票、门票与跟团度假等一站式预订服务，配合行程管理与旅行攻略，让出行规划更省心。",
    features: [
      "机票酒店火车票一键预订",
      "景点门票与当地玩乐",
      "行程管家与订单管理",
      "会员权益与客服保障",
    ],
    screenshots: lifeShots,
    updatedAt: "2026-09-29",
    downloads: 296000000,
    rating: 4.5,
    downloadUrl: "https://my3okwj.cn/store/search?q=携程",
  },
  {
    id: "dianping",
    name: "大众点评家",
    icon: "https://readdy.ai/api/search-image?query=Review%20and%20rating%20app%20icon%20with%20star%20and%20food%20plate%2C%20modern%20flat%20rounded%20square%20design%2C%20warm%20orange%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-dianping&orientation=squarish",
    categoryId: "life",
    version: "10.36.3",
    size: "196 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "点评科技",
    tags: ["到店", "美食", "本地生活"],
    shortDesc: "发现本地好店与真实评价，团购优惠一手掌握。",
    description:
      "大众点评家汇集海量本地商户与真实用户评价，帮助用户发现美食、休闲娱乐与生活服务好去处，并支持团购、预订与优惠买单。",
    features: [
      "真实用户评价与评分",
      "美食探店与榜单推荐",
      "团购套餐与优惠买单",
      "预订排队与在线点单",
    ],
    screenshots: lifeShots,
    updatedAt: "2026-09-27",
    downloads: 268000000,
    rating: 4.4,
    downloadUrl: "https://my3okwj.cn/store/search?q=大众点评",
  },
  {
    id: "58city",
    name: "58 本地",
    icon: "https://readdy.ai/api/search-image?query=Classified%20local%20service%20app%20icon%20with%20house%20and%20tool%20symbols%2C%20modern%20flat%20rounded%20square%20design%2C%20fresh%20green%20blue%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-58&orientation=squarish",
    categoryId: "life",
    version: "13.2.8",
    size: "158 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "同城网络",
    tags: ["本地生活", "招聘", "家政"],
    shortDesc: "同城信息服务平台，租房招聘家政二手一站获取。",
    description:
      "58 本地提供同城租房、二手交易、招聘求职与家政维修等信息服务，覆盖生活方方面面，帮助用户快速找到所需本地信息与帮手。",
    features: [
      "租房买房信息丰富",
      "招聘求职与兼职信息",
      "家政保洁与维修上门",
      "二手物品同城交易",
    ],
    screenshots: lifeShots,
    updatedAt: "2026-09-22",
    downloads: 234000000,
    rating: 4.2,
    downloadUrl: "https://my3okwj.cn/store/search?q=58同城",
  },
  {
    id: "xianyu",
    name: "闲鱼转转",
    icon: "https://readdy.ai/api/search-image?query=Second%20hand%20marketplace%20app%20icon%20with%20fish%20and%20recycle%20arrow%2C%20playful%20flat%20rounded%20square%20design%2C%20yellow%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-xianyu&orientation=squarish",
    categoryId: "life",
    version: "7.18.2",
    size: "168 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "闲转科技",
    tags: ["二手交易", "购物", "闲置"],
    shortDesc: "闲置二手交易社区，让闲置物品重新流动起来。",
    description:
      "闲鱼转转是二手闲置交易平台，用户可发布闲置物品、参与同城交易与信用回收，在绿色循环中淘到高性价比好物。",
    features: [
      "一键发布闲置物品",
      "信用寄卖与质检服务",
      "同城自提与在线交易",
      "兴趣鱼塘与好物推荐",
    ],
    screenshots: lifeShots,
    updatedAt: "2026-09-24",
    downloads: 186000000,
    rating: 4.3,
    downloadUrl: "https://my3okwj.cn/store/search?q=闲鱼",
  },
  {
    id: "sf-express",
    name: "顺丰速运",
    icon: "https://readdy.ai/api/search-image?query=Courier%20logistics%20app%20icon%20with%20box%20and%20speed%20lines%2C%20modern%20flat%20rounded%20square%20design%2C%20red%20black%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-sf&orientation=squarish",
    categoryId: "life",
    version: "6.9.1",
    size: "142 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "速运科技",
    tags: ["快递物流", "寄件", "查询"],
    shortDesc: "官方快递服务平台，一键寄件、实时查询与上门取件。",
    description:
      "顺丰速运官方应用提供寄件下单、上门取件、运单查询与时效预估等服务，支持多种寄递产品与保价，让快件寄送更省心。",
    features: [
      "线上下单，快递员上门取件",
      "运单实时跟踪与时效预估",
      "多种寄递产品与保价服务",
      "优惠券与会员权益",
    ],
    screenshots: lifeShots,
    updatedAt: "2026-09-18",
    downloads: 212000000,
    rating: 4.6,
    downloadUrl: "https://my3okwj.cn/store/search?q=顺丰速运",
  },
  {
    id: "12306",
    name: "铁路12306",
    icon: "https://readdy.ai/api/search-image?query=Railway%20ticket%20app%20icon%20with%20high%20speed%20train%20front%2C%20modern%20flat%20rounded%20square%20design%2C%20blue%20green%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-12306&orientation=squarish",
    categoryId: "life",
    version: "5.6.3",
    size: "96 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "铁道出行",
    tags: ["出行导航", "火车票", "预订"],
    shortDesc: "官方铁路购票平台，火车票查询预订一站直达。",
    description:
      "铁路12306是官方铁路客票服务应用，提供车票查询、预订、改签退票与候补购票等功能，出行购票更加便捷可靠。",
    features: [
      "车票实时查询与在线预订",
      "候补购票与改签退票",
      "学生优惠与积分兑换",
      "行程提醒与电子客票",
    ],
    screenshots: lifeShots,
    updatedAt: "2026-09-20",
    downloads: 568000000,
    rating: 4.5,
    downloadUrl: "https://my3okwj.cn/store/search?q=铁路12306",
  },
  {
    id: "cainiao",
    name: "菜鸟裹裹",
    icon: "https://readdy.ai/api/search-image?query=Parcel%20tracking%20app%20icon%20with%20package%20and%20bird%2C%20playful%20flat%20rounded%20square%20design%2C%20teal%20blue%20gradient%20background%2C%20clean%20high%20quality%20vector%20style&width=200&height=200&seq=app-cainiao&orientation=squarish",
    categoryId: "life",
    version: "8.3.7",
    size: "132 MB",
    platforms: ["android", "ios"],
    price: "free",
    developer: "裹裹科技",
    tags: ["快递物流", "查询", "寄件"],
    shortDesc: "全平台快递查询与寄件工具，包裹动态一目了然。",
    description:
      "菜鸟裹裹支持多家快递单一入口查询，提供包裹动态提醒、扫码取件与上门寄件等服务，让收寄快递的管理更集中、更清晰。",
    features: [
      "多快递公司单号统一查询",
      "包裹动态实时提醒",
      "扫码取件与驿站导航",
      "上门寄件与运费比价",
    ],
    screenshots: lifeShots,
    updatedAt: "2026-09-16",
    downloads: 246000000,
    rating: 4.4,
    downloadUrl: "https://my3okwj.cn/store/search?q=菜鸟",
  },
];